const ResetMyPassword = () => import('@/modules/user/views/ResetMyPassword')

const routes = [
  {
    path: '/user/reset-my-password',
    name: 'reset-my-password',
    component: ResetMyPassword,
    meta: {
        requiresAuth: true,        
        title: 'Reset Password',
        breadcrumb: null
    }
  }
]

export default routes
